// extracted by mini-css-extract-plugin
export default {"svgSignup":"RegistrationPage_svgSignup__ZyJ+c"};